/*---------------------------------------*/
/* ページ読み込み */
/*---------------------------------------*/
// $(window).load(function() {
// 		$('.CM').css( 'display', 'block'); //0は表示までのミリ秒数です。表示を1秒にする場合は1000に設定。
// });


/*---------------------------------------*/
/* スライダー 4枚*/
/*---------------------------------------*/

$(".slider04").slick({
speed: 700,
slidesToShow: 4,
slidesToScroll: 4,
useTransform: false,
dots: true,
prevArrow: '<button type=button class=slider_prev><img src="//shop.shimogamosaryo.co.jp/cdn/shop/files/arrow_circle_left.svg?v=7482421856715609597" alt="" loading="lazy"></button>',
nextArrow: '<button type=button class=slider_next><img src="//shop.shimogamosaryo.co.jp/cdn/shop/files/arrow_circle_right.svg?v=13480656952233087076" alt="" loading="lazy"></button>',
cssEase: 'ease-out',
responsive: [
	{
		breakpoint: 749, // 399px以下のサイズに適用
		settings: {
		slidesToShow: 1,
		centerMode: true,
		arrows: false,
		slidesToScroll: 4,
		},
	},
	],
});


/*---------------------------------------*/
/* スライダー 4枚*/
/*---------------------------------------*/

$(".slider-mv").slick({
	slidesToScroll: 4,
autoplay: false, 
centerMode: true,
speed: 700,
centerPadding: "0",
useTransform: false,
dots: true,
prevArrow: '<button type=button class=slider-prev><img src="//shop.shimogamosaryo.co.jp/cdn/shop/files/arrow_circle_left.svg?v=7482421856715609597" alt="" loading="lazy"></button>',
nextArrow: '<button type=button class=slider-next><img src="//shop.shimogamosaryo.co.jp/cdn/shop/files/arrow_circle_right.svg?v=13480656952233087076" alt="" loading="lazy"></button>',
cssEase: 'ease-out',
responsive: [
	{
		breakpoint: 749, 
		settings: {
		slidesToShow: 1,
		centerMode: true,
		centerPadding: "7%",
		},
	},
]
})

/*-------------------------------------------
アコーディオン
-------------------------------------------*/
$(function () {
if (window.matchMedia("(max-width: 749px)").matches) {
	$('.js-acd-button').click(function(){
		$(this).next('').slideToggle();
		$(this).toggleClass('is-open');
	});
}

$('.js-acd-button2').click(function(){
		$(this).next('').slideToggle();
		$(this).toggleClass('is-open');
});
});

/*---------------------------------------*/
/* Custom-collections もっと見る*/
/*---------------------------------------*/

$('.CC_more').on('click', function() {
    $(this).addClass('hidden');
    $('.CC_list_item').addClass('active');
});



/*-------------------------------------------
ヘッダーfixed
-------------------------------------------*/
window.addEventListener('scroll', function() {
	var header = document.querySelector('sticky-header');
	var scrollPosition = window.scrollY;

	if (scrollPosition > 100) {
	header.classList.add('fixed');
	} else {
	header.classList.remove('fixed');
	}
});


/*-------------------------------------------
カート
-------------------------------------------*/
const cartGiftInput = document.querySelector('.chakra-checkbox__input');
const cartGiftControl = document.querySelector('.chakra-checkbox__control');

if (cartGiftInput && cartGiftControl && cartDeliveryBox) {
  cartGiftControl.addEventListener('click', function () {
    if (!cartGiftInput.hasAttribute('data-checked')) {
      cartDeliveryBox.style.display = 'none';
    } else {
      cartDeliveryBox.style.display = 'block';
    }
  });
}

